<template>
    <app-layout :title="$t('Customers')">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ $t('Customers') }}
            </h2>
        </template>


        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <form @submit.prevent="submitSearch"
                  class="flex bg-white shadow-sm sm:rounded-lg overflow-hidden mb-5">
                <div class="flex-grow flex items-center p-3">
                    <input type="text" class="border-none w-full focus:outline-none focus:ring-0"
                           :placeholder="$t('Search...')" v-model="searchForm.sq"/>
                </div>
                <div class="flex-shrink-0 flex items-center justify-center">
                    <button type="button" @click.prevent="resetSearch"
                            class="py-3 px-4 text-gray-500 hover:text-gray-700"
                            v-if="searchForm.sq && searchForm.sq.length > 0"
                            :disabled="searchForm.processing" :class="{'opacity-25':searchForm.processing}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                    <button type="submit" class="py-3 px-4 text-primary-500 hover:text-primary-700"
                            :disabled="searchForm.processing" :class="{'opacity-25':searchForm.processing}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                        </svg>
                    </button>
                </div>
            </form>
            <div class="flex flex-col">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        #
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {{ $t('Customer') }}
                                    </th>
                                    <th scope="col" class="relative px-6 py-3">
                                        &nbsp;
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">
                                <template v-if="customers && customers.data && customers.data.length > 0">
                                    <tr v-for="customer in customers.data">
                                        <td class="px-6 py-4 whitespace-nowrap">
                                            <div class="flex items-center">
                                                <div class="text-sm font-medium text-gray-400">
                                                    {{ customer.internal_uid }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap">
                                            <div class="flex items-center">
                                                <div class="text-sm font-medium text-gray-900">
                                                    <div class="text-lg text-primary-500">
                                                        <Link :href="customer.show_url"
                                                              class="text-primary-600 hover:text-primary-900">
                                                            {{ customer.name }}
                                                        </Link>
                                                    </div>
                                                    <div class="text-sm text-gray-400">
                                                        {{ customer.company }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <div class="flex items-center justify-end space-x-3">
                                                <Link :href="customer.show_url"
                                                      class="text-primary-600 hover:text-primary-900">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6"
                                                         fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                              stroke-width="2" d="M9 5l7 7-7 7"/>
                                                    </svg>
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="6" class="px-6 py-4 whitespace-nowrap text-center">
                                            {{ $t('No data available.') }}
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <pagination class="mt-6" :links="customers.links"></pagination>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import {Link} from '@inertiajs/vue3';
import Pagination from "@/Components/Pagination"
import AppLayout from '@/Layouts/AppLayout.vue'
import debounce from 'lodash/debounce';

export default defineComponent({
    components: {
        AppLayout,
        Link,
        Pagination,
    },

    watch: {
        'searchForm.sq': {
            handler: debounce(function (newValue) {
                this.submitSearch();
            }, 250)
        }
    },

    props: {
        customers: Object,
        activeFilter: Object,
    },

    data() {
        return {
            searchForm: this.$inertia.form({
                sq: this.activeFilter.sq ? this.activeFilter.sq : null,
            }),
        };
    },

    methods: {
        submitSearch() {
            this.searchForm.get(route('consultant-customers.index'), {
                preserveScroll: true,
                preserveState: true,
            });
        },

        resetSearch() {
            this.$inertia.get(route('consultant-customers.index'), {}, {
                preserveScroll: true,
                preserveState: false,
            });
        },
    }
})
</script>
